import TmsGeneralPdf from '../assets/tms-general.pdf';
import RubberPdf from '../assets/rubber.pdf';
import TmsRdPdf from '../assets/tms-arge.pdf';
import TmsMotorPdf from '../assets/tms-motor.pdf';
import TmsRollingStock from '../assets/tms-rolling-stock.pdf';
import TmsSignaling from '../assets/tms-signaling.pdf';
import TmsPlanck from '../assets/tms-planck.pdf';

export const CATALOGS_TR = [
    {
        name: "GENEL",
        file: TmsGeneralPdf
    },
    {
        name: "AR-GE",
        file: TmsRdPdf
    },
    {
        name: "MARS KAUÇUK",
        file: RubberPdf
    },
    {
        name: "MOTOR",
        file: TmsMotorPdf
    },
    {
        name: "ROLLING STOCK",
        file: TmsRollingStock
    },
    {
        name: "SİNYALİZASYON",
        file: TmsSignaling
    },
    {
        name: "PLANCK",
        file: TmsPlanck
    }
];

export const CATALOGS_EN = [
    {
        name: "GENERAL",
        file: TmsGeneralPdf
    },
    {
        name: "R&D",
        file: TmsRdPdf
    },
    {
        name: "RUBBER",
        file: RubberPdf
    },
    {
        name: "MOTOR",
        file: TmsMotorPdf
    },
    {
        name: "ROLLING STOCK",
        file: TmsRollingStock
    },
    {
        name: "SIGNALLING",
        file: TmsSignaling
    },
    {
        name: "PLANCK",
        file: TmsPlanck
    }
];

export const CATALOGS_DE = [
    {
        name: "Allgemein",
        file: TmsGeneralPdf
    },
    {
        name: "Forschung & Entwicklung",
        file: TmsRdPdf
    },
    {
        name: "Rubber",
        file: RubberPdf
    },
    {
        name: "Motor",
        file: TmsMotorPdf
    },
    {
        name: "Rolling Stock",
        file: TmsRollingStock
    },
    {
        name: "Signaltechnik",
        file: TmsSignaling
    },
    {
        name: "Planck",
        file: TmsPlanck
    }
]